// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login {\n  width: 100%;\n  min-height: 100vh;\n  background: #17162b url('/assets/img/sign-bg3.png') no-repeat center;\n  background-size: cover;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.login::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -1;\n}\n.login-block {\n  position: relative;\n  background: transparent;\n}\n", ""]);
// Exports
module.exports = exports;
